export default {"src":"/_next/static/media/email.c2574f86.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};